import { createContext, useContext } from 'react';

type toggleModalParam = { name: string; forceStateValue?: boolean; data?: Record<string, unknown> };

export type ModalManagerContextType = {
  currentActionNotificationTypeName?: string | null;
  isNotificationVisible?: boolean;
  modifiedProductModalData?: { courseId?: string };
  toggleModal: (param: toggleModalParam) => () => void;
};

const ModalManagerContext = createContext<ModalManagerContextType>({
  currentActionNotificationTypeName: undefined,
  isNotificationVisible: false,
  modifiedProductModalData: undefined,
  toggleModal: () => () => undefined,
});

export const useModalManager = () => useContext(ModalManagerContext);

export default ModalManagerContext;
